import { APP_LOCALES, APP_NAMESPACES, createI18nConfig, defaultLocale, supportedLocales } from "@cronika/locales";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...createI18nConfig({
      locales: APP_LOCALES,
      namespaces: APP_NAMESPACES,
      defaultNS: "common:common",
      fallbackNS: "common",
      fallbackLng: defaultLocale,
    }),
    detection: {
      order: ["path", "cookie", "localStorage", "navigator"],
      lookupCookie: "locale",
      lookupLocalStorage: "locale",
      caches: ["cookie", "localStorage"],
      cookieMinutes: 60 * 24 * 365, // 1 year
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
export { defaultLocale, supportedLocales };
